// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"c93qmT5opG"};